module.exports = __webpack_public_path__ + "static/citi-yes-c90e5a2a1c49f849f339ad0f957f5e06.png";